import { render, staticRenderFns } from "./feedback-popup.vue?vue&type=template&id=4a3d8b3e&scoped=true&lang=pug&"
import script from "./feedback-popup.vue?vue&type=script&lang=js&"
export * from "./feedback-popup.vue?vue&type=script&lang=js&"
import style0 from "./feedback-popup.vue?vue&type=style&index=0&id=4a3d8b3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3d8b3e",
  null
  
)

export default component.exports